import { render, staticRenderFns } from "./DocumentsCommerciauxEspace.vue?vue&type=template&id=a96afb44&scoped=true&"
import script from "./DocumentsCommerciauxEspace.vue?vue&type=script&lang=js&"
export * from "./DocumentsCommerciauxEspace.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsCommerciauxEspace.vue?vue&type=style&index=0&id=a96afb44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96afb44",
  null
  
)

export default component.exports